// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","title":"_2IbHD4FVxtBnbNHEUw2mS3","mobileThreshold":"575px","btn":"UIl7LFSPy39JiGHoWAhI9","btnAccept":"_2Lyd3f-JpqegL46ETPO7I9","btnNoAccept":"wIyzZq5eyi5OzcIBs__bH"};


//////////////////
// WEBPACK FOOTER
// ./src/common/modal-sweet/ModalSweet.css
// module id = 841
// module chunks = 0